import { render, staticRenderFns } from "./GSnackBar.vue?vue&type=template&id=aef84ef0&scoped=true&"
import script from "./GSnackBar.vue?vue&type=script&lang=js&"
export * from "./GSnackBar.vue?vue&type=script&lang=js&"
import style0 from "./GSnackBar.vue?vue&type=style&index=0&id=aef84ef0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aef84ef0",
  null
  
)

export default component.exports